<template>
	<div>加载中</div>
</template>

<script>

export default {
	
    data() {
        return {
			
        }
    },
	
	created() {
		
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		
		// 获取特定参数的值
		const token = params.get('token');
		const fromPath = params.get('fromPath');
		window.localStorage.setItem('APP','bankScreen')
		
		console.log(token); // '11'
		console.log(fromPath); // '1'
		window.localStorage.setItem('NMYDATAASSTSTOKEN', token)
		window.localStorage.setItem('fromPath', fromPath)
		this.$http({
		    url: '/admin-service/getInfo',
		    //请求方式
		    method: 'get',
		    //传递的参数
		    data: {
		        extsysCode: 100000010
		    },
		
		}).then(res => {
		    if (res.data.code === 200) {
				if(res.data.user.enterpriseModel&&res.data.user.enterpriseModel.companyBankType>0){
					this.$router.replace(
						{path:'/branchScreen'}
					)
				}else{
					this.$router.replace(
						{path:'/bankScreen'}
					)
				}
			}
		})
		
	},
	methods:{
		
	}
	

};
</script>

<style>
</style>